module.exports = __webpack_public_path__ + "static/PMB_hills_instructions-28623149de6ea9d52fce3393b03a0d57.png";